module.exports = __webpack_public_path__ + "static/img/img_logo.7d9bc8e2.png";